export default __webpack_public_path__ + "static/media/mapMarker.648b2846.png";